<template>
  <CrearUsuario></CrearUsuario>
</template>

<script>
import CrearUsuario from "../../components/HistoricoDomicilios.vue";

export default {
  components: {
    CrearUsuario
  }
};
</script>
